"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightTrackingEventType = void 0;
exports.FreightTrackingEventType = {
    CREATED: 'CREATED',
    TENDERED: 'TENDERED',
    ESTIMATED_PICKUP_DATE_CHANGED: 'ESTIMATED_PICKUP_DATE_CHANGED',
    PICKED_UP: 'PICKED_UP',
    LOCATION_UPDATED: 'LOCATION_UPDATED',
    ESTIMATED_DELIVERY_DATE_CHANGED: 'ESTIMATED_DELIVERY_DATE_CHANGED',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED',
    CONTAINER_FULL_INGATED: 'CONTAINER_FULL_INGATED',
    CONTAINER_DEPARTED: 'CONTAINER_DEPARTED',
    CONTAINER_BERTHED_AT_TRANSSHIPMENT_PORT: 'CONTAINER_BERTHED_AT_TRANSSHIPMENT_PORT',
    CONTAINER_LOADED_AT_TRANSSHIPMENT_PORT: 'CONTAINER_LOADED_AT_TRANSSHIPMENT_PORT',
    CONTAINER_DEPARTED_FROM_TRANSSHIPMENT_PORT: 'CONTAINER_DEPARTED_FROM_TRANSSHIPMENT_PORT',
    CONTAINER_BERTHED: 'CONTAINER_BERTHED',
    CONTAINER_DISCHARGED: 'CONTAINER_DISCHARGED',
    CONTAINER_AVAILABLE: 'CONTAINER_AVAILABLE',
    CONTAINER_RETURNED: 'CONTAINER_RETURNED'
};
//# sourceMappingURL=freight-tracking-event-type.js.map